import React, {Fragment, useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser, faEnvelope, faLock, faKey, faPen} from "@fortawesome/free-solid-svg-icons";
import {useForm} from "react-hook-form";
import {FormInputIcon, CenteredModal, VerificationCodeInput, FormInput} from "~/components";
import {useUserAvatar} from '~/pages/context/UserAvatarContext';
import AuthAPI from '~/api/authApi';
import {useNavigate} from "react-router-dom";
import { toast } from 'react-toastify';
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import {Oval} from "react-loader-spinner";
import './index.css';

function AccountSecurityTab({title}) {
    const [isDisableSavePassword, setIsDisableSavePassword] = useState(true);
    const [isDisableSaveLoginInfor, setIsDisableSaveLoginInfor] = useState(true);
    const [deleteAccount, setDeleteAccount] = useState(false);
    const [enable2FA, setEnable2FA] = useState(false);
    const [auth2FaDatas, setAuth2FaDatas] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [showConfirmPwdModal, setShowConfirmPwdModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessage2Fa, setErrorMessage2Fa] = useState("");
    const [rememberSignin, setRememberSignin] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hasTwoFactor, setHasTwoFactor] = useState(false);
    const [showDisable2FA, setShowDisable2FA] = useState(false);
    const navigate = useNavigate();
    const {getImageUrlById} = useAssetsImage();
    const {userAvatar} = useUserAvatar();
    const authenIcon = getImageUrlById(36);
    const {
        register: registerInfo,
        handleSubmit: handleSubmitInfo,
        reset: resetInfo,
        formState: { errors: errorsInfo }
    } = useForm();

    const {
        register: registerPwd,
        handleSubmit: handleSubmitPwd,
        reset: resetPwd,
        watch: watchPwd,
        getValues: getPendingPwd,
        formState: { errors: errorsPwd }
    } = useForm();

    const {
        register: registerD2Fa,
        handleSubmit: handleSubmitD2Fa,
        reset: resetD2Fa,
        formState: { errors: errorsD2Fa }
    } = useForm();

    useEffect(() => {
        AuthAPI.hasTwoFactor()
            .then((res) => {
                setHasTwoFactor(res.data.TwoFactorEnabled)
            })
            .catch((err) => {
                
            })
    }, [showDisable2FA])

    const onSubmitFormUpdatePassword = (data) => {
        setErrorMessage("");
        AuthAPI.checkPassword(data.Password)
            .then((res) => {
                if(!res.data?.Succeeded){
                    setErrorMessage(res.data.Message);
                }
                else{
                    setRememberSignin(false);
                    setShowConfirmPwdModal(true);
                }
            })
            .catch((err) => {
                ;
            })
    }

    const onSubmitFormUpdateInfoLogin = () => {

    }

    const handleCancelPassword = () =>{
        setIsDisableSavePassword(true)
        resetPwd({
            Password: "",
            NewPassword: "",
            RePassword: ""
        })
        setShowPassword(false);
        setShowNewPassword(false);
        setShowRePassword(false);
        setErrorMessage("")
    }

    const handleCancelLoginInfo = () => {
        setIsDisableSaveLoginInfor(true)
        resetInfo({
            UserName: userAvatar.UserName,
            Email: userAvatar.Email
        })
    }

    const handleConfirmChangePwd = () => {
        const payload ={
            ...getPendingPwd(),
            IsContinueSignIn: rememberSignin
        }
        AuthAPI.changePassword(payload)
            .then((res) => {
                if(res.data?.Succeeded){
                    if(!rememberSignin){
                        navigate('/auth/signin', { replace: true });
                    }
                    else{
                        toast.success(<span className="fs-9 fw-bold">{res.data?.Message}</span>)
                    }
                }
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">{err.response?.data.Message}</span>)
            })
            .finally(() => {
                setShowConfirmPwdModal(false);
            })
    }

    const handleEnable2fa = () => {
        setLoading(true);
        AuthAPI.enable2Fa()
            .then((res) => {
                if(res.data?.Succeeded){
                    setAuth2FaDatas(res.data)
                    setEnable2FA(true);
                }
                else{
                    toast.error(<span className="fs-9 fw-bold">An error occurred while enabling 2FA.</span>)
                }
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const handleCallbackVerifyCode = (res) => {
        if (res.data?.Succeeded){
            toast.success(<span className="fs-9 fw-bold">Enable 2FA authenticator success.</span>)
        }
    }

    const handleDisable2fa = () => {
        setErrorMessage2Fa("");
        resetD2Fa({
            AdminPassword: ""
        })
        setShowDisable2FA(true);
    }

    const onSubmitFromDisable2FA  = (data) => {
        AuthAPI.disable2Fa({
            Password: data.AdminPassword
        })
            .then((res) => {
                if(res.data?.Succeeded){
                    toast.success(<span className="fs-9 fw-bold">Disable 2FA authenticator success.</span>)
                    setShowDisable2FA(false);
                }
                else{
                    setErrorMessage2Fa(res.data?.Message);
                }
            })
            .catch((err) => {
                ;
            })
    }

    return (
        <Fragment>
            <div className="mb-6">
                <h4 className="mb-4 text-center">{title}</h4>
                <div className="row gx-3 mb-4 gy-6 gy-sm-3">
                    <div className="col-12 col-sm-6">
                        <h5 className="mb-4">Change Info Login</h5>
                        <form onSubmit={handleSubmitInfo(onSubmitFormUpdateInfoLogin)} id="formUpdateInfoLogin">
                            <div className="mb-3">
                                <FormInputIcon
                                    showHeaderLabel={false}
                                    name="UserName"
                                    errors={errorsInfo}
                                    required={true}
                                    maxLengthText=""
                                    icon={faUser}
                                    label="Username"
                                    disabled={isDisableSaveLoginInfor}
                                    defaultValue={userAvatar.UserName}
                                    validation={{...registerInfo("UserName", {
                                            required: "UserName is required",
                                            pattern: {
                                                value: /^[A-Za-z0-9]{7,}$/,
                                                message: "UserName must be at least 7 characters and contain only letters or numbers (no spaces)."
                                            }
                                        })}}
                                />
                            </div>
                            <div className="mb-3">
                                <FormInputIcon
                                    showHeaderLabel={false}
                                    name="Email"
                                    errors={errorsInfo}
                                    required={true}
                                    maxLengthText=""
                                    icon={faEnvelope}
                                    label="Email"
                                    disabled={isDisableSaveLoginInfor}
                                    defaultValue={userAvatar.Email}
                                    validation={{...registerInfo("Email", {
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Invalid email address"
                                            }
                                        })}}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-sm-6">
                        <h5 className="mb-4">Change Password</h5>
                        <form onSubmit={handleSubmitPwd(onSubmitFormUpdatePassword)} id="formUpdatePassword">
                            <div className="mb-3">
                                <FormInputIcon
                                    showHeaderLabel={false}
                                    name="Password"
                                    type={showPassword ? "text": "password"}
                                    errors={errorsPwd}
                                    required={true}
                                    maxLengthText=""
                                    icon={faLock}
                                    label="Old Password"
                                    disabled={isDisableSavePassword}
                                    validation={{...registerPwd("Password", {
                                            required: "Password is required",
                                    })}}
                                    isShowHideIcon={true}
                                    onClickShowHide={() => setShowPassword(!showPassword)}
                                    showPassword={showPassword}
                                />
                            </div>
                            <div className="mb-3">
                                <FormInputIcon
                                    showHeaderLabel={false}
                                    name="NewPassword"
                                    type={showNewPassword ? "text": "password"}
                                    errors={errorsPwd}
                                    required={true}
                                    maxLengthText=""
                                    icon={faKey}
                                    label="New Password"
                                    disabled={isDisableSavePassword}
                                    validation={{...registerPwd("NewPassword", {
                                            required: "New Password is required.",
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
                                                message: "Password must have at least 6 characters, 1 lowercase, 1 uppercase, 1 number and 1 special character."
                                            }
                                        })}}
                                    isShowHideIcon={true}
                                    onClickShowHide={() => setShowNewPassword(!showNewPassword)}
                                    showPassword={showNewPassword}
                                />
                            </div>
                            <div className="mb-3">
                                <FormInputIcon
                                    showHeaderLabel={false}
                                    name="RePassword"
                                    type={showRePassword ? "text": "password"}
                                    errors={errorsPwd}
                                    required={true}
                                    maxLengthText=""
                                    icon={faKey}
                                    label="Confirm Password"
                                    disabled={isDisableSavePassword}
                                    validation={{...registerPwd("RePassword", {
                                            required: "Confirm Password is required.",
                                            validate: value =>
                                                value === watchPwd("NewPassword") || "Passwords do not match."
                                        })}}
                                    isShowHideIcon={true}
                                    onClickShowHide={() => setShowRePassword(!showRePassword)}
                                    showPassword={showRePassword}
                                />
                            </div>
                            {
                                errorMessage && (
                                    <p className="fs-9 fw-bold text-danger text-center">{errorMessage}</p>
                                )
                            }
                        </form>
                    </div>
                </div>
                <div className="row gx-3 mb-4 gy-6 gy-sm-3">
                    <div className="col-12 col-sm-6">
                        <div className="text-center mb-6">
                            <div>
                                {
                                    !isDisableSaveLoginInfor &&
                                    <button className="btn btn-bt-secondary me-2" onClick={handleCancelLoginInfo}>Cancel</button>
                                }
                                {
                                    isDisableSaveLoginInfor &&
                                    <button className="btn btn-bt-primary me-2" onClick={() => setIsDisableSaveLoginInfor(false)}>Edit
                                        <FontAwesomeIcon className="ms-3" icon={faPen}/>
                                    </button>
                                }
                                <button type="submit" form="formUpdateInfoLogin" disabled={isDisableSaveLoginInfor} className="btn btn-bt-primary">Save Changes</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6">
                        <div className="text-center mb-6">
                            <div>
                                {
                                    !isDisableSavePassword &&
                                    <button className="btn btn-bt-secondary me-2" onClick={handleCancelPassword}>Cancel</button>
                                }
                                {
                                    isDisableSavePassword &&
                                    <button className="btn btn-bt-primary me-2" onClick={() => setIsDisableSavePassword(false)}>Edit
                                        <FontAwesomeIcon className="ms-3" icon={faPen}/>
                                    </button>
                                }
                                <button type="submit" form="formUpdatePassword" disabled={isDisableSavePassword} className="btn btn-bt-primary">Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gx-3 mb-6 gy-6 gy-sm-3">
                    <div className="col-12 col-sm-6">
                        <h5 className="mb-3">Two Factor Authentication</h5>
                        {hasTwoFactor ? (
                            <>
                                <p className="mt-1 fs-8-1 mb-3 text-success">
                                    Two-Factor Authentication is currently <strong>enabled</strong> on your account.
                                    Your account is more secure with an extra verification step.
                                </p>
                                <div className="text-center">
                                    <button
                                        className="btn btn-bt-primary border-success me-2"
                                        onClick={handleDisable2fa}
                                    >
                                        Disable 2FA
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="mt-1 fs-8-1 mb-3 text-muted">
                                    To enhance your account security, we strongly recommend enabling
                                    Two-Factor Authentication (2FA). This extra layer of protection helps
                                    prevent unauthorized access, even if your password is compromised.
                                </p>
                                <div className="text-center">
                                    <button
                                        className="btn btn-bt-primary me-2"
                                        disabled={enable2FA}
                                        onClick={handleEnable2fa}
                                    >
                                        Enable 2FA
                                    </button>
                                </div>
                            </>
                        )}
                        {
                            loading && (
                                <div className="d-flex justify-content-center mt-10">
                                    <Oval
                                        height="30"
                                        width="30"
                                        color="#2f5aa2"
                                        ariaLabel="oval-loading"
                                    />
                                </div>
                            )
                        }
                        {
                            !loading && enable2FA && (
                                <div>
                                    <div className="progress-steps">
                                        <div className="complete">
                                            <h1>
                                                <span className="number">1</span>
                                                Download app
                                            </h1>
                                            Download a mobile authentication app.
                                            <div className="my-2">
                                                <img src={authenIcon} alt="authenticator" className="rounded-3" width={50}/>
                                            </div>
                                        </div>

                                        <div className="complete">
                                            <h1>
                                                <span className="number">2</span>
                                                Scan QR Code
                                            </h1>
                                            Scan this QR code using a mobile authentication app. This will
                                            generate a verification code or enter the key manually.
                                            <div>
                                                Key: <strong>{auth2FaDatas.Key}</strong>
                                            </div>
                                            <div className="mt-2 pb-3">
                                                <img
                                                    src={`https://api.qrserver.com/v1/create-qr-code/?data=${auth2FaDatas.AuthenticatorUri}&size=200x200`}
                                                    alt="QR Code"
                                                    className="img-thumbnail"
                                                    style={{ maxWidth: "200px" }}
                                                />
                                            </div>
                                        </div>

                                        <div className="complete">
                                            <h1>
                                                <span className="number">3</span>
                                                Enter Code
                                            </h1>
                                            Enter the 2-step verification code from your authenticator app.
                                            <VerificationCodeInput formId='formInput2FaCode'
                                                                   onCompleteChange={(comp) => {
                                                                       setIsComplete(comp);
                                                                   }}
                                                                   onCallback={handleCallbackVerifyCode}
                                                                   apiUrl="/auth/verify-2fa-code"
                                            />
                                        </div>
                                        <div></div>
                                    </div>
                                    <div className="text-center mt-5">
                                        <button type="submit" form="formInput2FaCode" disabled={!isComplete} className="btn btn-bt-primary me-3">Verify 2FA Code</button>
                                        <button className="btn btn-bt-secondary"
                                                onClick={() => setEnable2FA(false)}
                                        >Cancle</button>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="col-12 col-sm-6">
                        <h5 className="text-body-emphasis mb-3">Account Deletion</h5>
                        <p className="fs-8-1">Transfer this account to another person or to a company repository.</p>
                        <div className="text-center">
                            <button className="btn btn-bt-danger"
                                    disabled={deleteAccount}
                                    onClick={ () => setDeleteAccount(true)}
                            >Delete account</button>
                        </div>
                        {
                            deleteAccount && (
                                <div className="text-center mt-3">
                                    <h4 className="text-body-emphasis">Delete your account permanently?</h4>
                                    <p className="fs-8-1 mt-4">You are about to permanently delete your account. This action <b
                                        className="text-danger">cannot be undone</b>.
                                        All your data and preferences will be removed.</p>
                                    <div className="">
                                        <div className="text-start">
                                            <label className="fs-9 fw-bold" htmlFor="deleteConfirmPassword">Enter Password to confirm (required)</label>
                                            <input required="" placeholder="Enter Password" id="deleteConfirmPassword" className="form-control" type="text"/>
                                        </div>
                                        <div className="mt-4">
                                            <button className="btn btn-bt-danger me-3 border-danger">Leave and Delete Account</button>
                                            <button className="btn btn-bt-secondary"
                                                    onClick={ () => setDeleteAccount(false)}
                                            >Cancle</button>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <CenteredModal show={showConfirmPwdModal}
                           onClose={() => setShowConfirmPwdModal(false)}
                           title="Confirm Change Password"
                           confirmText="Save Changes"
                           onConfirm={handleConfirmChangePwd}
            >
                <div>
                    <span className="fs-8-1 fw-bold">Are you sure you want to change your password?</span>
                    <div className="form-check">
                        <input id="checkedCheckbox" className="form-check-input" type="checkbox" defaultChecked={rememberSignin} onChange={(e) => setRememberSignin(e.target.checked)} />
                        <label title="" htmlFor="checkedCheckbox" className="form-check-label">Continue signin after change password.</label>
                    </div>
                    <span className="fs-8-1 fw-bold text-warning">If you do not check <strong>"Continue signin after change password"</strong>, you will be logged out.</span>
                </div>
            </CenteredModal>

            <CenteredModal show={showDisable2FA} closeText="Cancel" formId="formDisable2FA"
                           confirmText="Disable" onClose={() => setShowDisable2FA(false)}
                           title= "Disable Two-Factor Authentication">
                <p className="fs-8-1 text-center">
                    <strong className="text-danger">Disabling 2FA</strong> will make your account less secure. Are you sure you want to proceed?
                </p>
                {
                    errorMessage2Fa &&
                    (
                        <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                            <span className="text-danger fw-bold fs-9">{errorMessage2Fa}</span>
                        </div>
                    )
                }
                <div>
                    <span className="fs-9 fw-bold" >Enter your password to confirm</span>
                </div>
                <form onSubmit={handleSubmitD2Fa(onSubmitFromDisable2FA)} id="formDisable2FA">
                    <FormInput showHeaderLabel={true}
                               name = "AdminPassword"
                               errors={errorsD2Fa}
                               required={true}
                               label="Assign Password"
                               maxLengthText=""
                               validation={{...registerD2Fa("AdminPassword", {
                                       required: "Password is required."
                                   })}}
                               showHeaderLabel = {false}
                    />
                </form>
            </CenteredModal>
        </Fragment>
    )
}

export default AccountSecurityTab;